/*
 * Module for the Benefit Payroll Deduction Register criteria page
 */
rs.module("content/reports/criteria/benefitpayrolldeductionregistercriteria",

    ["controls/data/grid"],

    function (gridModule) {

        function initialize(lrsGridApi, jsSelectors, ajaxUrls, compositeMonthYearColumnID) {
            var filter = $.js(jsSelectors.filter);
            var includeManualCheckBox = filter.js(jsSelectors.includeManualCheckBox);
            var includeLumpSumsCheckBox = filter.js(jsSelectors.includeLumpSumsCheckBox);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            includeManualCheckBox.change(filterCheckBoxChanged);
            includeLumpSumsCheckBox.change(filterCheckBoxChanged);

            // refresh the grid based on checkbox selection
            function filterCheckBoxChanged() {
                loadingSpinner.show();
                gridModule.update(
                    ajaxUrls.refreshGridUrl,

                    { includeManualPayroll: includeManualCheckBox.is(':checked'), includeLumpSums: includeLumpSumsCheckBox.is(':checked') },

                    lrsGridApi.agGridApi,

                    function done() {
                        loadingSpinner.hide();
                    }
                );
            }

            var payrollProcessingMonthYearHidden = $.js(jsSelectors.payrollProcessingMonthYearHidden);

            // Populate the hidden field for PayrollProcessingMonthYear with the value of the selected grid row
            lrsGridApi.selectionChanged(function (values, rows) {

                if (values.length > 0) {
                    var compositeMonthYear = rows[0][compositeMonthYearColumnID];
                    payrollProcessingMonthYearHidden.val(compositeMonthYear);
                } else {
                    payrollProcessingMonthYearHidden.val('');
                }
            });
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);